<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
    <path
      d="M12.5052 7.50313H14.1725C15.0934 7.50313 15.8399 8.24963 15.8399 9.17049V15.8399C15.8399 16.7608 15.0934 17.5073 14.1725 17.5073H5.83574C4.91488 17.5073 4.16838 16.7608 4.16838 15.8399V9.17049C4.16838 8.24963 4.91488 7.50313 5.83574 7.50313H7.5031"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.0041 2.50104V12.5052"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5052 10.0042L10.0041 12.5052L7.5031 10.0042"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup lang="ts" />
